// extracted by css-extract-rspack-plugin
export default {"iconContainer":"_4af74fd4"};